
export const SECTORS = [
  "Agro-alimentaire",
  "Automobile",
  "Banque / Assurance",
  "BTP / Construction",
  "Commerce / Distribution",
  "Conseil",
  "Éducation / Formation",
  "Énergie / Environnement",
  "Hôtellerie / Restauration",
  "Immobilier",
  "Industrie",
  "Informatique / Télécom",
  "Luxe / Mode",
  "Média / Communication",
  "Santé / Pharmaceutique",
  "Transport / Logistique",
  "Autre"
];

export const LEGAL_FORMS = [
  "SAS",
  "SASU",
  "SA",
  "SARL",
  "EURL",
  "Association Loi 1901",
  "EI (auto-entrepreneur, micro-entreprise)",
];

// For the contact form, we'll filter out ineligible forms
export const LABEL_LEGAL_FORMS = [
  "SAS",
  "SASU",
  "SA",
  "SARL",
  "EURL",
];

// Employee count options
export const EMPLOYEE_COUNTS = [
  "0 à 10",
  "11 à 49",
  "50 à 99",
  "100 et plus"
];

// Funding options
export const FUNDING_OPTIONS = [
  "Oui",
  "Non"
];
